module.exports = __webpack_public_path__ + "img/logo-header-white.d491d125.png";